module.exports = __webpack_public_path__ + "img/GU.23c45130.png";